import pako from 'pako';

export const createAnswerHtml = (text: string) => {
  // Regex to find ‹...› markers
  const markerRegex = /‹([^›]+)›/g;

  // Replace each marker with an <a> tag
  return text.replace(markerRegex, (_match, id) => {
    // you can customize href here if you have a different URL pattern
    const href = `#${id}`;
    return `<a id="${id}" href="${href}"style="color:blue">&lt;Cite&gt;</a>`;
  });
};

export const uniqueById = (items: any[]): any[] => {
  const ids = items.map((ele) => ele._id);
  console.log('item ids', ids);
  const seen = new Set<string>();
  return items.filter((item) => {
    if (seen.has(item._id.toString())) {
      console.log('already seen', item._id.toString());
      return false;
    }
    seen.add(item._id.toString());
    return true;
  });
};

/**
 * @param base64 Gzipped JSON, encoded as Base64
 */
export function unzipJson<T = any>(base64: string): T {
  // 1. Decode Base64 → binary string
  const binaryString = atob(base64);

  // 2. Convert binary string to Uint8Array
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // 3. Use pako to ungzip → UTF-8 string
  const jsonString = pako.ungzip(bytes, { to: 'string' });

  // 4. Parse
  return JSON.parse(jsonString);
}

// export function escapeAndStripEndingPunctuation(text: string): string {
//   // Step 1: Remove sentence-ending punctuation if it appears at the end
//   const stripped = text.replace(/[.!?]$/, '');

//   // Step 2: Escape regex special characters: . * + ? ^ $ { } ( ) | [ ] \ / ' "
//   return stripped.replace(/[-\/\\^$*+?.()|[\]{}']/g, '\\$&').trim();
// }

export function escapeAndStripEndingPunctuation(text: string): string {
  // Step 1: Remove sentence-ending punctuation if it appears at the end
  var stripped = text.replace(/[.!?]$/, '');

  // Step 2: Escape regex special characters ONLY if not already escaped
  var specials = /[-\/\\^$*+?.()|[\]{}'"]/;
  var result = '';
  for (var i = 0; i < stripped.length; i++) {
    var char = stripped[i];
    var prev = i > 0 ? stripped[i - 1] : '';
    if (specials.test(char) && prev !== '\\') {
      result += '\\' + char;
    } else {
      result += char;
    }
  }

  return result.trim();
}

export function extractHtmlAndSnippets(content: string): {
  htmlBeforeSnippets: string;
  parsedSnippets: Record<string, string[]>;
} {
  const [htmlPart, snippetPart] = content.split(/---SNIPPETS---/);
  console.log('SNIPPET PART OF ANSWER', snippetPart);
  const htmlBeforeSnippets = htmlPart.trim();
  const parsedSnippets: Record<string, string[]> = {};

  const snippetRegex = /\{\{\{(.*?)\}\}\}/g;
  let match: RegExpExecArray | null;

  while ((match = snippetRegex.exec(snippetPart)) !== null) {
    const inner = match[1].trim();
    const [contextId, ...excerpts] = inner.split(':::').map((s) => s.trim());
    parsedSnippets[contextId] = excerpts
      .map((excerpt) => excerpt.replace(/^"+|"+$/g, '').trim())
      .filter(Boolean);
  }

  return { htmlBeforeSnippets, parsedSnippets };
}

export function extractIdsFromAnswer(text: string): string[] {
  const regex = /‹(.*?)›/g;
  const matches: string[] = [];
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (!matches.includes(match[1])) {
      matches.push(match[1]);
    }
  }

  return matches;
}


